import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import team3 from 'assets/img/team/3.jpg';
import Avatar from 'components/common/Avatar';
import { logout } from 'functions/userAuth';
import avatarImg from 'assets/img/team/avatar.png';
import AppContext from 'context/Context';
const API = process.env.REACT_APP_API_PATH;


const ProfileDropdown = () => {
  const _userData=JSON.parse(localStorage.getItem('userData'));
  //const [userData,setUserData]=useState(null);
  const { setConfig } = useContext(AppContext);

useEffect(()=>{

 // setUserData(_userData);
console.log('userData',_userData);

},[])


// Event handler for logout
const handleLogout = () => {
  logout();
  // Redirect the user or perform additional actions as needed
};

const handleCustomizeClick = () => {
  setConfig('showSettingPanel', true);
};

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
          <div className="d-flex align-items-center justify-content-center">
          <div className="flex-1" style={{marginRight:'5px'}}><h5 className="mb-0 fs--1">{_userData && _userData.contactPerson}</h5></div>
        <Avatar style={{ width: '45px', height: '45px' }} src={_userData && _userData.profilePic!=null ? `${API}/file/image/${_userData.profilePic}` : avatarImg} />
{/* {JSON.stringify(userData)} */}
        </div>
       

      </Dropdown.Toggle>
      {/* {JSON.stringify(userData)} */}
      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          {/* <Dropdown.Item className="fw-bold text-warning" href="#!">
            <FontAwesomeIcon icon="crown" className="me-1" />
            <span>Go Pro</span>
          </Dropdown.Item> */}
          <Dropdown.Divider />
          {/* <Dropdown.Item href="#!">Set status</Dropdown.Item> */}
         
      
          <Dropdown.Item as={Link}   to={`/support-desk/user-profile/${_userData && _userData.userId}`}>
            Profile &amp; account
          </Dropdown.Item>
          {/* <Dropdown.Item href="#!">Feedback</Dropdown.Item> */}
          <Dropdown.Divider />
      
          <Dropdown.Item as={Link} >     {/* to="/user/settings" */}
            Settings
          </Dropdown.Item>
          <Dropdown.Item onClick={handleCustomizeClick} >     {/* to="/user/settings" */}
            Customize
          </Dropdown.Item>
          <Dropdown.Item as={Link} to="/authentication/simple/login" onClick={handleLogout}>
            Logout
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
